import { gql } from "@apollo/client";

/**
 * Blocks or unblocks one country.
 *
 * `blocked` is **the state to set, not a flip**, so a double-tap or a retried
 * request is a no-op that returns the current row rather than toggling twice.
 *
 * Returns one row of the list shape, which is why this screen patches the row
 * in place instead of refetching: a re-read can land on an instance that has
 * not expired its 30s cache yet and would report the pre-write value, making a
 * successful save look like it failed.
 *
 * `blockedBy` is filled in from the admin's own token — never send it.
 *
 * `phoneBlocked` is selected here as well as on the list: it is what lets the
 * confirmation say "Jamaica blocked — IP addresses only" instead of implying
 * the country's numbers are now being turned away too.
 *
 * Errors: `INVALID_COUNTRY_CODE` (not two letters, or not a real country) and
 * `FORBIDDEN` (missing or non-admin token). Both arrive as HTTP 200 with an
 * `errors` array, so never branch on status — see `describeToggleFailure`.
 */
export const SET_COUNTRY_BLOCKED = gql`
  mutation SetCountryBlocked($countryCode: String!, $blocked: Boolean!) {
    setCountryBlocked(countryCode: $countryCode, blocked: $blocked) {
      countryCode
      name
      phoneCode
      blocked
      phoneBlocked
      phoneBlockingNote
      blockedAt
      blockedBy
    }
  }
`;
